import { useProfile } from 'context/profile';

import NotificationPreferences from './NotificationPreferences';

export default function UserNotificationPreferences() {
  const { profile } = useProfile();

  return <NotificationPreferences user={profile} />;
}
